import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faCheck, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import defaultPdfImage from "../Assets/orangepdf.png";
import { isDocFailed, isDocReady } from "./useDocumentUploads";

const statusLine = (doc) => {
  if (doc.status === "uploading") return "Uploading…";
  if (isDocFailed(doc)) return doc.message || "Failed";
  if (isDocReady(doc)) return doc.message || "Ready";
  const pct = typeof doc.pct === "number" && doc.pct > 0 ? ` · ${Math.round(doc.pct)}%` : "";
  return `${doc.message || "Processing"}${pct}`;
};

/** Composer chips: thumbnail, name, live status, remove button. */
const AttachmentChips = ({ docs, onRemove }) => {
  if (!docs.length) return null;

  return (
    <div className="att-chips">
      {docs.map((doc) => {
        const ready = isDocReady(doc);
        const failed = isDocFailed(doc);
        const busy = !ready && !failed;
        const pct = Math.max(0, Math.min(100, doc.pct || 0));

        return (
          <div
            key={doc.key}
            className={`att-chip${ready ? " is-ready" : ""}${failed ? " is-failed" : ""}`}
            title={doc.error || doc.name}
          >
            <div className="att-chip-thumb">
              <img src={doc.previewUrl || defaultPdfImage} alt="" />
              {ready && (
                <span className="att-chip-badge"><FontAwesomeIcon icon={faCheck} /></span>
              )}
              {failed && (
                <span className="att-chip-badge"><FontAwesomeIcon icon={faTriangleExclamation} /></span>
              )}
              {busy && <span className="att-chip-spinner" aria-hidden="true" />}
            </div>

            <div className="att-chip-body">
              <div className="att-chip-name">{doc.name}</div>
              <div className="att-chip-status" aria-live="polite">{statusLine(doc)}</div>
              {busy && doc.status !== "uploading" && (
                <div className="att-chip-bar"><span style={{ width: `${pct}%` }} /></div>
              )}
            </div>

            <button
              type="button"
              className="att-chip-remove"
              onClick={() => onRemove(doc.key)}
              aria-label={`Remove ${doc.name}`}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default React.memo(AttachmentChips);